import { useState, useMemo } from 'react';
import BasicFormInput from './BasicFormInput';

import styles from '../styles/Autocomplete.module.css';

const randChar = `!@#$%^&*()-_=+[]{}|;:,.<>?/~`;

export default function MultiAutocomplete({
  inputLabel,
  optionsData,
  className,
  placeholder,
  onValueChange = () => {}
}) {
  const separator = useMemo(() => {
    let randStr = '';
    for (let i = 0; i < 8; i++) {
      const index = Math.floor(Math.random() * randChar.length);
      randStr += randChar[index];
    }
    return randStr;
  }, []);

  const [search, setSearch] = useState('');
  const options = useMemo(
    () =>
      optionsData.filter(({ label }) =>
        label.toLowerCase().includes(search.toLowerCase())
      ),
    [search, optionsData]
  );

  const updateReference = {
    search: setSearch,
    selected: (val) => {
      const [label, value] = val.split(separator);
      onValueChange({ label, value });
    },
    reset: () => {
      setSearch('');
    }
  };

  function myChangeHandler(e) {
    const { name, value } = e.target;
    updateReference[name](value);
  }

  return (
    <div className={className}>
      <div className={styles.searchContainer}>
        <BasicFormInput
          placeholder={placeholder}
          label={inputLabel}
          updateKey='search'
          value={search}
          onChange={myChangeHandler}
        />
        <button
          type='button'
          className={styles.reset}
          onClick={myChangeHandler}
          name='reset'
        >
          x
        </button>
      </div>
      <div className={styles.optionsContainer}>
        {options.length > 0 &&
          options.map(({ label, value }, idx) => (
            <button
              type='button'
              className={styles.option}
              onClick={myChangeHandler}
              name='selected'
              key={idx}
              value={`${label}${separator}${value}`}
            >
              {label}
            </button>
          ))}
      </div>
    </div>
  );
}
